// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"79":"c24846cfd991e8f4","957":"ea6a741b04623239"}[chunkId] + ".js";
};